import * as serviceTypes from '../../../data/booking/constants/service_types';
import moment from "moment";
import {routes} from "../../../data/booking/constants/editable_routes";

const getBagTransportSummary = (service) => {
    const stepCount = service.items.length;
    let bags = 0;
    service.items.forEach(item => {
        if (item.bags > bags) {
            bags = item.bags;
        }
    });

    return stepCount + ' étape' + (stepCount>1 ? 's' : '');
};

const getBikeTransportSummary = (service) => {
    const stepCount = service.items.length;
    return stepCount + ' étape' + (stepCount>1 ? 's' : '');
};

const getPeopleTransportSummary = (service) => {
    const stepCount = service.items.length;
    let people = 0;
    service.items.forEach(item => {
        if (item.people > people) {
            people = item.people;
        }
    });

    return people + (people > 1 ? ' personnes' : ' personne');
};

const getRegularShuttleSummary = (service) => {
    if (service.items.length <= 0) {
        return '';
    }

    const item = service.items[0];
    // let from = item.from.stop.title;
    // let to = item.to.stop.title;

    // return item.people + ' personnes / ' + from + ' => ' + to;
    return item.people + (item.people > 1 ? ' personnes' : ' personne');
};

const getCarTransportSummary = (service) => {
    if (service.items.length <= 0) {
        return '';
    }

    const item = service.items[0];
    // let from = item.from.stop.title;
    // let to = item.to.stop.title;

    return item.vehicleCount + (item.vehicleCount > 1 ? ' véhicules' : ' véhicule');
};

const getCarParkingSummary = (service) => {
    if (service.items.length <= 0) {
        return '';
    }

    const item = service.items[0];
    // let from = item.from.stop.title;
    // let to = item.to.stop.title;

    return item.vehicleCount + (item.vehicleCount > 1 ? ' véhicules' : ' véhicule');
};

const getServiceSummary = (service) => {
    switch (service.type) {
        case serviceTypes.BAG_TRANSPORT:
            return getBagTransportSummary(service);
        case serviceTypes.BIKE_TRANSPORT:
            return getBikeTransportSummary(service);
        case serviceTypes.PEOPLE_TRANSPORT:
            return getPeopleTransportSummary(service);
        case serviceTypes.REGULAR_SHUTTLE:
            return getRegularShuttleSummary(service);
        case serviceTypes.CAR_TRANSPORT:
            return getCarTransportSummary(service);
        case serviceTypes.CAR_PARKING:
            return getCarParkingSummary(service);
    }

    return '';
};

const getHasBagTransportService = (services) => {
    return services.some(service => service.type == serviceTypes.BAG_TRANSPORT)
}

const isServiceEditable = (item, service, booking) => {
    let date = item.date ? item.date : item.startDate

    // si devis
    if(booking.type == 'quotation' ||
        // si resa et service à plus de 3 jours
        (booking.type == 'reservation' && moment().add(3, 'days').isBefore(moment(date))) ||
        // si resa et service transport de bagage et route editable et date service à - de 3 jours
        (booking.type == 'reservation' && service.type == serviceTypes.BAG_TRANSPORT && routes.includes(service.route.id))
            && moment().add(3, 'days').isSameOrAfter(moment(date))
    ){
        return true
    }
    return false;
}
const isServiceDisabled = (service, booking) => {
    let date = service.date ? service.date : service.startDate
    if(booking.type == 'quotation' || (moment().isBefore(moment(date)))){
        return false
    }
    return true;
}

export {
    getServiceSummary,
    getHasBagTransportService,
    isServiceEditable,
    isServiceDisabled
};
